import rightArrow from "../../Assets/HourlyData/rightArrow.svg";
import HourlyData from "../../Assets/HourlyData/hourlyData.svg";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logoAndTitleFunction from "../../AllFunctions/logoAndTitleFunction";
import { extractTimeWithAMPM } from "../../AllFunctions/formattedDateAndTime";

function HourlyForcast() {
  const { hourlyWeatherData } = useSelector((store) => store.dashboard);

  return (
    <div className="  flex flex-col  gap-2 h-full   rounded-lg bg-primaryBgColor dark:bg-darkModePrimaryBgColor p-2 " >
      {/* ================header part ========================= */}
      <div className="flex justify-between py-1  ">
        <div className="flex   items-center font-semibold text-blackPrimaryText dark:text-darkModeBlackPrimaryText  gap-2  ">
          <img src={HourlyData} alt="" />
          <p>Hourly Forecast</p>
        </div>
        <Link to="/hourly-forcast-table">
          <div className="flex text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-semibold bg-cardBgColor dark:bg-darkModeSecondaryBgColor rounded-md items-center gap-2  px-4 py-0.5 border border-gray-200 dark:border-white/10 shadow-sm transition-all duration-300  ">
            <button className="" type="button">more </button>
            <img width={"6px"} src={rightArrow} alt="rightArrow" />
          </div>
        </Link>
      </div>
      {/* ================header part ========================= */}
      {/* =========================hourly forcast mapping ================ */}
      <div className="flex gap-2 text-blackPrimaryText dark:text-darkModeBlackPrimaryText overflow-auto h-full ">
        {hourlyWeatherData?.slice(0, -1).map((hourlypara, index) => (
          <div
            className="flex flex-col justify-between items-center py-2 px-4 bg-cardBgColor dark:bg-darkModeCardBgColor border border-gray-200 dark:border-white/10 rounded-lg mb-2 shadow-sm hover:shadow-md transition-all duration-300 "
            key={index}
          >
            <p className="lg:w-[5vw]  text-center text-[12px] font-bold">
              {extractTimeWithAMPM(hourlypara.Date_time)}
            </p>
            <img className="w-[50px]" src={logoAndTitleFunction(hourlypara).logo} alt={logoAndTitleFunction(hourlypara).title} />
            <p className="text-[14px] font-semibold  min-w-[60px]">{logoAndTitleFunction(hourlypara).title}</p>


            <p className="text-[16px] font-bold">
              {Math.trunc(hourlypara.Tavg) + "°C"}
            </p>
          </div>
        ))}
      </div>
      {/* =========================hourly forcast mapping ================7*/}
    </div>
  );
}

export default HourlyForcast;
